export default "/images/5e90a9e01ae88036f5ddf03588c96780.avif";